import { capitalize } from "@mui/material/utils";
import { getStaffFoodSourcesForRegion } from "@notemeal/food-utils";
import { FoodDataSource } from "@notemeal/graphql-types";
import { useRegion } from "apps/web/src/hooks/useRegion";
import React from "react";
import LabeledSelectNoId from "../../../universal/LabeledSelectNoId";

interface FoodDataSourceSelectProps {
  source: FoodDataSource;
  isEdit: boolean;
  disabled?: boolean;
  error: boolean;
  helperText?: string;
  onChange: (value: string) => void;
}

export const FoodDataSourceSelect = ({ source, isEdit, disabled, error, helperText, onChange }: FoodDataSourceSelectProps) => {
  const { region } = useRegion();

  // mccance/ausnut are CSV-ingested — only keep them visible when already the food's source
  const dataSources = getStaffFoodSourcesForRegion(region).filter(
    fs =>
      (fs !== FoodDataSource.mccance && fs !== FoodDataSource.ausnut) || (isEdit && fs === source)
  );

  return (
    <LabeledSelectNoId
      selectedOption={source}
      placeholder="Food Source"
      options={dataSources}
      error={error}
      helperText={helperText}
      optionToName={(name: string) => capitalize(name)}
      disabled={disabled}
      onChange={t => onChange(t)}
    />
  );
};
